import React, { useState, useEffect } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { useMediaQuery } from "@mui/material";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AddIcon from "@mui/icons-material/Add";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomSnackbar from "../../../CustomSnackbar";
import TabelSkeleton from "../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import { HelpOutline } from "@material-ui/icons";

// import { toast } from "react-toastify";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});
function Addrole() {
  const matches = useMediaQuery("(max-width:700px)");
  const [openModel, setOpenModel] = useState(false);
  const [togglebutton, settogglebutton] = useState(null);
  const [getroledata, setGetRoleData] = useState([]);
  const [rolename, setRoleName] = useState("");
  const [rolenameError, setRoleNameError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [roleid, setRoleId] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [userloader, setUserLoader] = useState(false);
  const [deleteId, setDeleteID] = useState(true);
  const [searchApi, setSearchAPi] = useState([])
  function notFound() {
    var notFound = document.getElementById("notFound");
    notFound.innerHTML = "Person not found in Address Book";
  }

  // const searchItem = (e) => {
  //   setSearchInput(e.target.value);

  //  if(e.target.value !== ""){
  //   const filterData = getroledata.filter(o=>Object.keys(o).some(k=>
  //     String(o[k].toString().toLowerCase().includes(e))

  //     ));

  //     setFilterData([...filterData])

  //  }else{
  //   setSearchInput(e.target.value);
  //   setGetRoleData([...getroledata])

  //  }
  //
  //
  // };

  const classes = useStyles();

  const handleOpenModel = () => {
    setOpenModel(true);
  };

  const handleCloseModel = () => {
    setOpenModel(false);
  };
  // get All Roles
  const get_role_data = () => {
    setStatusLoading(true);
    var axios = require("axios");

    var config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/Role/getAllRoles`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        setGetRoleData(response.data);
        setSearchAPi(response.data)
        setStatusLoading(false);
      })
      .catch(function (error) { });
  };

  //Add All roles
  const add_role_data = (e) => {
    var axios = require("axios");
    e.preventDefault();
    setRoleNameError(false);
    if (rolename === "") {
      setRoleNameError(true);
    } else {
      setUserLoader(true);

      var config = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/api/Role/CreateRole?name=${rolename}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then(function (response) {
          get_role_data();
          setRoleName("");
          setOpenModel(false);
          setUserLoader(false);

          setSuccessMessage(response.data.message);
        })
        .catch(function (error) {
          setUserLoader(false);

          setErrorMessage(error.response.data.message);
        });
    }
  };

  const delete_role = (id) => {
    var axios = require("axios");
    setUserLoader(true);

    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/Role/DeleteRole?Id=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        get_role_data();
        setOpenModel(false);
        setUserLoader(false);

        setSuccessMessage(response.data.message);
        setDeleteID("");
      })
      .catch(function (error) {
        setUserLoader(false);

        setErrorMessage(error.response.data.message);
      });
  };

  const fetch_data_by_id = (id) => {
    var axios = require("axios");

    var config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/Role/getRoleById/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
    };

    axios(config)
      .then(function (response) { })
      .catch(function (error) { });
  };

  const update_Role = (id, name) => {
    var axios = require("axios");
    setUserLoader(true);

    var config = {
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/api/Role/UpdateRole?Id=${id}&Name=${name}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then(function (response) {
        get_role_data();
        setRoleName("");
        setOpenModel(false);
        setUserLoader(false);

        setSuccessMessage(response.data.message);
      })
      .catch(function (error) {
        setUserLoader(false);

        setErrorMessage(error.response.data.message);
      });
  };
  const handleSearchInput = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "") {
      setGetRoleData(searchApi)
    } else {
      const fiterData = searchApi.filter((data =>
        data.name
          .toLowerCase()
          .includes(inputValue.toLowerCase())


      ))
      if (fiterData.length > 0) {
        setGetRoleData(fiterData)

      } else {
        let msg = "No Records Found"
        setGetRoleData([{ message: msg }])
      }
    }
  }
  useEffect(() => {
    get_role_data();
  }, []);

  return (
    <div>
      <Box display="flex" justifyContent={"end"}>
        <Button
          variant="contained"
          size={"small"}
          color="secondary"
          sx={{
            color: "#fff",
            fontSize: matches ? "10px" : "15px",

            width: matches ? "117px" : "151px",
          }}
          onClick={() => {
            setDeleteID("");
            handleOpenModel();
            settogglebutton(null);
            setRoleName("");
            setRoleNameError(false);
          }}
        >
          {/* <AddIcon /> */}
          Add Role
        </Button>
      </Box>
      <Card style={{ marginTop: "24px" }}>
        <CardHeader color="primary" text>
          <CardText color="primary" style={{ padding: "0px 27px" }}>
            {/* <Box> */}
            <h4>Add/Edit Role Name</h4>

            {/* </Box> */}
          </CardText>
        </CardHeader>
        <CardBody>
          {/* <Button
            variant="contained"
            size={matches ? "small" : "large"}
            color="secondary"
            sx={{
              color: "#fff",
              fontSize: matches ? "10px" : "15px",

              width: matches ? "117px" : "151px",
            }}
            onClick={handleOpenModel}
          >
            
            Add User
          </Button> */}
          <Grid container spacing={2} pb={3}>
            <Grid item md={4} sx={3} mt={2} ml={1}>
              <TextField
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  }
                }}
                fullWidth
                id="outlined-basic"
                placeholder="Search here...."
                variant="outlined"
                type="search"
                // value={searchInput}

                onChange={(e) => {
                  handleSearchInput(e)
                  setSearchInput(e.target.value)

                }}
              />
            </Grid>
          </Grid>
          <TableContainer className="scrollable"
            sx={{
              height: 400
            }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
              sx={{
                height: "max-content"
              }}
            >
              <TableHead
                style={{
                  position: 'sticky',
                  top: '0px',
                }}
              >
                <TableRow sx={{ backgroundColor: "#A5ACB0" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    SR#
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                    Role Name
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{ fontWeight: "bold", color: "#fff" }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getroledata.map((item, index) => {
                  return (
                    <>
                      {item.message ? (
                        <>

                          <TableRow
                          // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                          >
                            <TableCell colSpan={3}
                              style={{

                                border: "none",
                                textAlign: "center",
                                padding: "20px",

                              }}
                            >
                              <Typography>No Records Found</Typography>

                            </TableCell>

                          </TableRow>
                        </>
                      ) : (
                        <TableRow key={index}>
                          <TableCell scope="row">{index + 1}</TableCell>
                          <TableCell>{item.name}</TableCell>

                          <TableCell align="right">
                            <Tooltip title="Edit">
                              <EditIcon
                                color="success"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID("");
                                  settogglebutton(1);

                                  fetch_data_by_id(item.id);
                                  setRoleId(item.id);
                                  setRoleName(item.name);

                                  handleOpenModel();
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="Delete">
                              <DeleteIcon
                                color="error"
                                sx={{ "&:hover": { cursor: "pointer" } }}
                                onClick={() => {
                                  setDeleteID(item.id);
                                  handleOpenModel();
                                }}
                              />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )}

                    </>
                  );
                })}
              </TableBody>
              {statusLoading && <TabelSkeleton noOfColumns={3} noOfLines={3} />}
            </Table>
            {getroledata?.length === 0 && !statusLoading ? <EmptyData /> : ""}

          </TableContainer>
        </CardBody>
      </Card>

      {/* //!Model for Add user */}
      <Dialog
        open={openModel}
        onClose={handleCloseModel}
        // sx={{ width: "60%" }}
        fullWidth={true}
      >
        {deleteId ? (
          <>
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={userloader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <HelpOutline color="secondary" fontSize="large" mt={2} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                p={2}
                mt={1}
              >
                <Typography variant="h4" style={{ width: "80%" }}>
                  Are you sure you want to Delete a User?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                m={1}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCloseModel}
                >
                  NO
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: "20px" }}
                  onClick={() => {
                    delete_role(deleteId);
                  }}
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </>
        ) : (
          <>
            <DialogTitle
              sx={{
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              Add Role
            </DialogTitle>
            <Divider />
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={userloader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Grid container spacing={2} pb={3}>
                <Grid item md={10} sx={3}>
                  <TextField
                    size="small"
                    fullWidth
                    id="outlined-basic"
                    label="Role Name"
                    variant="outlined"
                    value={rolename}
                    error={rolenameError}
                    onChange={(e) => {
                      setRoleName(e.target.value);
                      setRoleNameError(false);
                    }}
                  />
                  {rolenameError ? (
                    <>
                      <Typography variant="h6" component="h2" color="error">
                        Roll name is required
                      </Typography>
                    </>
                  ) : null}
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />

            <DialogActions>
              <Button
                variant="outlined"
                color="error"
                onClick={handleCloseModel}
              >
                Cancel
              </Button>
              {togglebutton ? (
                <Button
                  color="success"
                  variant="contained"
                  onClick={() => {
                    update_Role(roleid, rolename);
                  }}
                >
                  Updated
                </Button>
              ) : (
                <Button
                  color="success"
                  variant="contained"
                  onClick={add_role_data}
                >
                  Create
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* //! for listing Table */}
      {successMessage && (
        <CustomSnackbar
          open={true}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
    </div>
  );
}

export default Addrole;
